import React, { useState, useContext, useEffect } from 'react';
import { Button } from 'reactstrap';
import Alert from 'react-s-alert';
import ProviderInfo_1 from '../../assets/providerInfo1.svg';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';

// import services

// local imports
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';

const ProviderInfo1 = (props) => {

    const { theme } = useContext(ThemeContext);

    // states
    const [provider, setProvider] = useState({
        uniqueId: null
    });

    // useEffects
    useEffect(() => {
        try {
            const provider = JSON.parse(window.localStorage.getItem('provider') || "{}");
            if (JSON.stringify(provider) !== "{}") {
                setProvider(provider);
            } else {
                window.location.href = '/counsellors';
                // props.history.replace("/counsellors")
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Client MakePayment useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.location.state]);

    const handleSubmit = e => {
        e.preventDefault()
        try {
            props.history.push({
                pathname: "/counsellor/claimProfileStep2",
                state: {
                    provider: provider,
                }
            })
        } catch (err) {
            console.log('err', err)
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            })
        }
    }


    return (
        <div>
            <GeneralNavbar history={props.history} />
            <div className='wrapper text-center mb-5'>
                <h3 className='my-4' style={theme.headingXXL}>Join as Counsellor</h3>
            </div>
            <div className="row p-3 mb-3">
                <img className="col-md-6 col-12" src={ProviderInfo_1} alt="Work from your comfort" />

                <div className="col-md-6 col-12 my-auto">
                    <div>
                        <h5 className='my-2'>Claim Profile</h5>
                        <p>
                            Sign up as a Counsellor,  claim your profile and own your Counsellor Page.
                        </p>
                    </div>
                    <br />
                    <br />
                    <div>
                        <h5 className='my-2'>Give Counselling Services</h5>
                        <p>
                            Provide your Counselling Services, on UmangWellness platform through Chat, Call and Video for free.Charge your sessions through Custom Pricings or Subscriptions.
                        </p>
                    </div>
                    <br />
                    <br />
                    <div>
                        <h5 className='my-2'>Upgrade for more resources</h5>
                        <p>
                            Start with the free plan. And Upgrade to upper tier to unlock more resources.
                        </p>
                    </div>
                </div>
            </div>
            <div className='wrapper text-center mb-4'>
                <Button className="btn ml-auto mr-2 px-4" style={theme.button} onClick={handleSubmit}>Continue</Button>
            </div>
            <Footer />
        </div>
    )
}

export default ProviderInfo1